import type { Conversation } from "./types";

export const conversations: Conversation[] = [
  {
    id: "conv-demo-logistica",
    tenantId: "pgr-seguridad",
    company: "PGR Seguridad",
    customer: "Cliente Demo Logística",
    site: "Centro Sur",
    contactName: "Mesa Técnica Demo",
    phone: "+56 9 0000 0101",
    summary:
      "El cliente solicita revisar un NVR y dos cámaras desconectadas. Se debe coordinar visita técnica y emitir una cotización después del diagnóstico.",
    lastMessage: "Confírmame por favor si pueden venir el viernes en la mañana.",
    lastMessageAt: "18:12",
    unreadCount: 2,
    priority: "high",
    status: "waiting",
    assignedTo: "Equipo Técnico Demo",
    source: "demo",
    tags: ["mantenimiento", "cotización"],
    commitments: [
      {
        id: "task-1",
        description: "Confirmar horario de visita técnica",
        dueAt: "26 sep · 09:00",
        responsible: "Equipo Técnico Demo",
        status: "pending",
        sourceMessageId: "msg-3",
      },
      {
        id: "task-2",
        description: "Enviar cotización posterior al diagnóstico",
        responsible: "Equipo Comercial Demo",
        status: "pending",
        sourceMessageId: "msg-2",
      },
    ],
    messages: [
      {
        id: "msg-1",
        direction: "inbound",
        sender: "Mesa Técnica Demo",
        body: "Tenemos el NVR con una alarma y dos cámaras que aparecen desconectadas.",
        sentAt: "17:43",
        type: "text",
      },
      {
        id: "msg-2",
        direction: "inbound",
        sender: "Mesa Técnica Demo",
        body: "Después de revisar, necesitamos que nos envíen la cotización de la reparación.",
        sentAt: "17:45",
        type: "text",
      },
      {
        id: "msg-3",
        direction: "inbound",
        sender: "Mesa Técnica Demo",
        body: "Confírmame por favor si pueden venir el viernes en la mañana.",
        sentAt: "18:12",
        type: "text",
      },
    ],
  },
  {
    id: "conv-demo-industrial",
    tenantId: "pgr-seguridad",
    company: "PGR Seguridad",
    customer: "Cliente Demo Industrial",
    site: "Faena Norte",
    contactName: "Operaciones Demo",
    phone: "+56 9 0000 0202",
    summary:
      "Consulta comercial por alternativas de vigilancia nocturna y 24/7, incluyendo camioneta minera y alimentación.",
    lastMessage: "Quedamos atentos a ambas alternativas por separado.",
    lastMessageAt: "16:48",
    unreadCount: 0,
    priority: "normal",
    status: "open",
    assignedTo: "Equipo Comercial Demo",
    source: "demo",
    tags: ["oportunidad", "oferta"],
    commitments: [
      {
        id: "task-3",
        description: "Preparar oferta técnica y económica con dos alternativas",
        dueAt: "27 sep · 13:00",
        responsible: "Equipo Comercial Demo",
        status: "pending",
        sourceMessageId: "msg-4",
      },
    ],
    messages: [
      {
        id: "msg-4",
        direction: "inbound",
        sender: "Operaciones Demo",
        body: "Quedamos atentos a ambas alternativas por separado.",
        sentAt: "16:48",
        type: "text",
      },
    ],
  },
  {
    id: "conv-demo-accesos",
    tenantId: "seguridad-smart",
    company: "Seguridad Smart",
    customer: "Cliente Demo Accesos",
    site: "Acceso 10",
    contactName: "Administración Demo",
    phone: "+56 9 0000 0303",
    summary:
      "Reporte por barrera dañada. Se requiere visita, diagnóstico y separación de costos de desmontaje, reparación y programación.",
    lastMessage: "Adjunto foto del brazo después del choque.",
    lastMessageAt: "15:29",
    unreadCount: 1,
    priority: "urgent",
    status: "scheduled",
    assignedTo: "Equipo Técnico Demo",
    source: "demo",
    tags: ["incidente", "barrera"],
    commitments: [
      {
        id: "task-4",
        description: "Realizar visita de inspección",
        dueAt: "26 sep · 11:30",
        responsible: "Equipo Técnico Demo",
        status: "pending",
        sourceMessageId: "msg-5",
      },
    ],
    messages: [
      {
        id: "msg-5",
        direction: "inbound",
        sender: "Administración Demo",
        body: "Adjunto foto del brazo después del choque.",
        sentAt: "15:29",
        type: "image",
      },
    ],
  },
];
